<script lang="ts">
	/**
	 * Letterhead — page envelope.
	 *
	 * Optional eyebrow + date pair across the top, hairline beneath.
	 * Used at the head of a page (the home, /trust/, an essay) to set
	 * the "this is a letter" tone before the first headline lands.
	 */

	import type { Snippet } from 'svelte';

	interface Props {
		eyebrow?: string;
		date?: string;
		children: Snippet;
	}

	let { eyebrow, date, children }: Props = $props();
</script>

<div class="letterhead">
	{#if eyebrow || date}
		<div class="letterhead-meta">
			{#if eyebrow}
				<span class="letterhead-eyebrow">{eyebrow}</span>
			{/if}
			{#if date}
				<span class="letterhead-date">{date}</span>
			{/if}
		</div>
		<hr class="letterhead-rule" />
	{/if}
	<div class="letterhead-body">
		{@render children()}
	</div>
</div>

<style>
	.letterhead {
		display: block;
	}
	.letterhead-meta {
		display: flex;
		justify-content: space-between;
		align-items: baseline;
		gap: var(--ekavi-space-4);
		flex-wrap: wrap;
		padding-bottom: var(--ekavi-space-3);
	}
	.letterhead-eyebrow {
		font-family: var(--ekavi-font-mono);
		font-size: var(--ekavi-text-12);
		letter-spacing: var(--ekavi-track-caps);
		text-transform: uppercase;
		color: var(--ekavi-ink-3);
		font-weight: var(--ekavi-weight-halbfett);
	}
	.letterhead-date {
		font-family: var(--ekavi-font-mono);
		font-size: var(--ekavi-text-12);
		color: var(--ekavi-ink-3);
		font-variant-numeric: tabular-nums lining-nums;
	}
	.letterhead-rule {
		border: none;
		border-top: var(--ekavi-stroke-hairline);
		margin: 0;
	}
	.letterhead-body {
		padding-top: var(--ekavi-space-9);
	}
</style>
